import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import Loader from "../../../core/common/loader";
import { Switch } from "antd";
import DeleteModal from "../../../core/modals/deleteModal";
import LeadFormViewer from "./leadFormViewer";
import SharedFormLists from "./components/SharedFormLists";
import GenerateShareLinkModal from "./components/GenerateShareLinkModal";

import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  InputLabel,
  Chip,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CommonSelect from "../../../core/common/commonSelect";
import { notify } from "../../../services/toast.config";
import { humanReadableDate } from "../../../helper/dateTimeHelper";

interface FormField {
  id: number;
  label: string;
  type: "text" | "select" | "tel";
  options?: string[];
  required?: boolean;
  typeCheck: string;
}

const LeadsFormList = () => {
  useEffect(() => {
    // This will run when the component mounts
    const fetchDashboardData = async () => {
      try {
        await updateUI();
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      }
    };

    fetchDashboardData();
  }, []);

  const location = useLocation();

  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [getAllCompanyList, setgetAllCompanyList] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState(data);
  const [pipelineData, setpipelineData] = useState<any[]>([]);
  const [leadPipelineChoose, setLeadpipelineChoose] = useState<any[]>([]);
  const [dealPipelineChoose, setDealpipelineChoose] = useState<any[]>([]);

  const [selectedEmployees, setSelectedEmployees] = useState<any[]>([]);
  const [LeadEmployeesList, setLeadEmployeesList] = useState([]);

  const [isGenerateLinkModalOpen, setIsGenerateLinkModalOpen] = useState(false);
  const [selectedFormForSharing, setSelectedFormForSharing] =
    useState<any>(null);
  const [shareLinksRefreshKey, setShareLinksRefreshKey] = useState(0);

  const handleShareFormClick = (leadForm: any) => {
    setSelectedFormForSharing(leadForm);
    setIsGenerateLinkModalOpen(true);
  };

  const handleCloseGenerateLinkModal = () => {
    setIsGenerateLinkModalOpen(false);
    setSelectedFormForSharing(null);
  };

  const handleShareLinkSuccess = async () => {
    await updateUI();
    setShareLinksRefreshKey((prev) => prev + 1);
  };

  const employeesList = [
    ...LeadEmployeesList.map((empolyee: any) => ({
      value: empolyee.key,
      label: empolyee.Name,
    })),
  ];

  const handleEmployeeChange = (event: any) => {
    setSelectedEmployees(event.target.value);
  };

  const companyChoose = [
    ...getAllCompanyList.map((company) => ({
      value: company.id,
      label: `${company.name} - ${company.type}`,
    })),
  ];

  const updateUI = async () => {
    setIsLoading(true);
    const [getAllCompanyList, getLeadForms, allPipelines] = await Promise.all([
      api.post("userService/getAllCompanyList", { signature }),
      api.post("leadService/getAllLeadForms", { signature }),
      api.post("leadService/getAllPipelines", { signature }),
    ]);
    setgetAllCompanyList(getAllCompanyList.data.data.data);

    handleFilterCompanyChange({
      label:
        getAllCompanyList.data.data.data[0].name +
        "-" +
        getAllCompanyList.data.data.data[0].type,
      value: getAllCompanyList.data.data.data[0].id,
    });

    setData(getLeadForms.data.data.data);
    setFilteredData(getLeadForms.data.data.data);
    setpipelineData(allPipelines.data.data.data);

    setIsLoading(false);
    return;
  };

  const [formName, setFormName] = useState("");
  const [fields, setFields] = useState<FormField[]>([
    {
      id: 1,
      label: "Full Name",
      type: "text",
      required: true,
      typeCheck: "manual",
    },
    {
      id: 3,
      label: "Mobile No",
      type: "tel",
      required: true,
      typeCheck: "manual",
    },
    {
      id: 2,
      label: "Email",
      type: "text",
      required: true,
      typeCheck: "manual",
    },
  ]);

  const dynamicColumn = [
    { value: "text", label: "Text Field" },
    { value: "date", label: "Date" },
    { value: "country", label: "Country-State-City" },
    { value: "select", label: "Dropdown" },
    { value: "tel", label: "Mobile No" },
  ];

  const handleSelect = (event: any) => {
    const value = event.target.value;
    setFields([
      ...fields,
      {
        id: Date.now(),
        label: "",
        type: value,
        required: false,
        typeCheck:
          value != "text" && value != "date" && value != "select"
            ? "manaul"
            : "automatic",
        options: value != "text" && value != "date" ? [] : undefined,
      },
    ]);
  };

  // Update field properties
  const handleFieldChange = (id: number, key: keyof FormField, value: any) => {
    setFields(
      fields.map((field) =>
        field.id === id ? { ...field, [key]: value } : field
      )
    );
  };

  // Remove field
  const removeField = (id: number) => {
    setFields(fields.filter((field) => field.id !== id));
  };

  const resetForm = () => {
    setFormName("");
    setFields([
      {
        id: 1,
        label: "Full Name",
        type: "text",
        required: true,
        typeCheck: "manual",
      },
      {
        id: 3,
        label: "Mobile No",
        type: "tel",
        required: true,
        typeCheck: "manual",
      },
      {
        id: 2,
        label: "Email",
        type: "text",
        required: true,
        typeCheck: "manual",
      },
    ]);
    setformDataAddLeadForm(initialAddLeadFormData);
    setformDatapipeline(initialPipeLineData);
    setformDatadealpipeline(initialdealPipeLineData);
    setSelectedEmployees([]); // This will reset the multi-select
  };

  const saveForm = async () => {
    if (formDataAddLeadForm.companyId == "") {
      showBasicAlert("Please select company first.");
      return;
    }

    if (!formName.trim() || fields.length === 0) {
      showBasicAlert("Please Enter a form name.");
      return;
    }

    const hasMobile = fields.some((field) => field.label === "Mobile No");

    if (!hasMobile) {
      alert("Mobile No. must be provided.");
      return;
    }

    try {
      const response = await api.post("leadService/addLeadForm", {
        signature: signature,
        formName: formName,
        company_id: formDataAddLeadForm.companyId,
        structure: fields,
        pipeline_id: formDatapipeline.pipelineId,
        deal_pipeline_id: formDatadealpipeline.dealpipelineId,
        selectedEmployees: selectedEmployees,
      });
      updateUI();
      showBasicAlert(response.data.message[0].msg);
      document.getElementById("close-btn-lead-form")?.click();
      setFormName("");
      setformDataAddLeadForm(initialAddLeadFormData);
      setformDatapipeline(initialPipeLineData);
      setformDatadealpipeline(initialdealPipeLineData);
      setSelectedEmployees([]);
      setFields([
        {
          id: 1,
          label: "Full Name",
          type: "text",
          required: true,
          typeCheck: "manual",
        },
        {
          id: 2,
          label: "Email",
          type: "text",
          required: true,
          typeCheck: "manual",
        },
        {
          id: 3,
          label: "Mobile No",
          type: "text",
          required: true,
          typeCheck: "manual",
        },
      ]);
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };

  var initialAddLeadFormData = {
    signature: signature,
    companyName: "",
    companyId: "",
    companytype: "",
  };
  const [formDataAddLeadForm, setformDataAddLeadForm] = useState(
    initialAddLeadFormData
  );

  const [filterFormDataAddLeadForm, setFilterFormDataAddLeadForm] = useState(
    initialAddLeadFormData
  );

  const handleInputChange = async (e: any) => {
    const { label, value } = e;

    setformDataAddLeadForm({
      signature: signature,
      companyName: label.split("-")[0].trim(),
      companyId: value,
      companytype: label.split("-")[1].trim(),
    });

    const filteredDataPipeline = pipelineData.filter(
      (item) =>
        item.Company_Type == label.split("-")[1].trim() &&
        parseInt(item.Company_Id) == parseInt(value) &&
        item.Type == "lead"
    );
    setLeadpipelineChoose(filteredDataPipeline);

    const filteredDataPipelineDeal = pipelineData.filter(
      (item) =>
        item.Company_Type == label.split("-")[1].trim() &&
        parseInt(item.Company_Id) == parseInt(value) &&
        item.Type == "deal"
    );
    setDealpipelineChoose(filteredDataPipelineDeal);

    const [getLeadSettings] = await Promise.all([
      api.post("leadService/getAllLeadSettings", {
        signature,
        company_id: parseInt(value),
        company_type: label.split("-")[1].trim(),
      }),
    ]);
    if (getLeadSettings.data.data.data.length > 0) {
      const [getAllEmployeList] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(value),
          company_type: label.split("-")[1].trim(),
        }),
      ]);
      setLeadEmployeesList(getAllEmployeList.data.data.data.allUsers);
    } else {
      setLeadEmployeesList([]);
    }
  };

  const handleFilterCompanyChange = async (e: any) => {
    const { label, value } = e;
    setcompanyFilter(label.split("-")[0].trim());

    setFilterFormDataAddLeadForm({
      signature: signature,
      companyName: label.split("-")[0].trim(),
      companyId: value,
      companytype: label.split("-")[1].trim(),
    });
  };

  var initialPipeLineData = {
    pipelineName: "",
    pipelineId: "",
  };
  const [formDatapipeline, setformDatapipeline] = useState(initialPipeLineData);

  const handleInputPipelineChange = (e: any) => {
    const { name, value } = e.target;
    setformDatapipeline((prev: any) => ({ ...prev, [name]: value }));
  };

  var initialdealPipeLineData = {
    pipelineName: "",
    dealpipelineId: "",
  };
  const [formDatadealpipeline, setformDatadealpipeline] = useState(
    initialdealPipeLineData
  );

  const handleInputdealPipelineChange = (e: any) => {
    const { name, value } = e.target;
    setformDatadealpipeline((prev: any) => ({ ...prev, [name]: value }));
  };

  const [selectedStartDate, setSelectedStartDate] =
    useState<moment.Moment | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<moment.Moment | null>(
    null
  );

  const handleDateChange = (start: moment.Moment, end: moment.Moment) => {
    setSelectedStartDate(start);
    setSelectedEndDate(end);
  };
  const routes = all_routes;
  const columns = [
    {
      title: "Lead Form Name",
      dataIndex: "LeadFormName",
      render: (text: string) => <h6 className="fw-medium fs-14">{text}</h6>,
      sorter: (a: any, b: any) => a.LeadFormName.length - b.LeadFormName.length,
    },
    // {
    //   title: "Company Name",
    //   dataIndex: "CompanyName",
    //   render: (text: string, record: any) => (
    //     <div className="d-flex align-items-center file-name-icon">
    //       <Link
    //         to={`${routes.companiesDetails.replace(":id", record.CompanyId)}${location?.search
    //           }`}
    //         className="avatar avatar-md border rounded-circle">
    //         <ImageWithBasePath
    //           src={
    //             record.logo == null
    //               ? `assets/img/company/company-01.svg`
    //               : record.logo
    //           }
    //           className="img-fluid"
    //           alt="img"
    //         />
    //       </Link>
    //       <div className="ms-2">
    //         <h6 className="fw-medium">
    //           <Link
    //             to={`${routes.companiesDetails.replace(
    //               ":id",
    //               record.CompanyId
    //             )}${location?.search}`}>
    //             {text}
    //           </Link>
    //         </h6>
    //       </div>
    //     </div>
    //   ),
    //   sorter: (a: any, b: any) => a.CompanyName.length - b.CompanyName.length,
    // },
    // {
    //   title: "Company Type",
    //   dataIndex: "CompanyType",
    //   render: (text: string, record: any) => (
    //     <div className="d-flex align-items-center file-name-icon">
    //       <div className="ms-2">
    //         <h6 className="fw-medium">{text}</h6>
    //       </div>
    //     </div>
    //   ),
    //   sorter: (a: any, b: any) => a.CompanyType.length - b.CompanyType.length,
    // },
    {
      title: "Generate Link",
      dataIndex: "actions",
      align: "center",
      render: (text: string, record: any) => (
        <Link
          title="Generate Share Link"
          to="#"
          className="btn btn-outline-info btn-sm"
          onClick={(e) => {
            e.preventDefault();
            handleShareFormClick(record);
          }}>
          <i className="ti ti-share-3 me-1" />
          Share
        </Link>
      ),
    },
    {
      title: "Lead Pipeline",
      dataIndex: "Pipeline",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">{text}</h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Pipeline.length - b.Pipeline.length,
    },
    {
      title: "Deal Pipeline",
      dataIndex: "Pipeline_Deal",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <div className="ms-2">
            <h6 className="fw-medium">{text}</h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.Pipeline_Deal.length - b.Pipeline_Deal.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string) => (
        <>
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${text === "Active" ? "badge-success" : "badge-danger"
              }`}>
            <i className="ti ti-point-filled me-1"></i>
            {text}
          </span>
        </>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "CreatedDate",
      dataIndex: "CreatedDate",
      sorter: (a: any, b: any) => a.CreatedDate.length - b.CreatedDate.length,
      render: (date: any) => (
        <span className="text-muted">
          {humanReadableDate(date, true, undefined, undefined, false)}
        </span>
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Switch
            checked={record.Status == "Active" ? true : false}
            onChange={(checked) => handleToggle(record.key)}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ width: "50px" }}
          />
          <Link
            to="#"
            style={{ width: "50px" }}
            onClick={(e: any) => {
              e.preventDefault();
              var formDetail = [];
              formDetail.push(record);
              setFormData(formDetail);
              setFormViewOpen(true);
            }}>
            <i className="ti ti-eye" title="View" />
          </Link>
          <Link
            to="#"
            style={{ width: "50px" }}
            data-bs-toggle="modal"
            data-bs-target="#edit_leads_form"
            onClick={(e: any) => {
              e.preventDefault();
              handleEditForm(record);
            }}>
            <i className="ti ti-edit" title="Edit" />
          </Link>
          <Link
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            style={{ width: "50px" }}
            onClick={(e: any) => {
              e.preventDefault();
              setDeleteRecord(record);
            }}>
            <i className="ti ti-trash" title="Delete" />
          </Link>
        </div>
      ),
    },
  ];

  const handleToggle = async (key: any) => {
    try {
      const response = await api.post("leadService/editLeadForm", {
        signature: signature,
        id: key,
      });
      updateUI();
      showBasicAlert(response.data.message[0].msg);
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };

  //Filter
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sortBy, setSortBy] = useState<string>("Last 7 Days");
  const [companyFilter, setcompanyFilter] = useState<string | null>(null);

  const handleReset = () => {
    setFilteredData(data);
    setStatusFilter("");
    setcompanyFilter("");
    setSortBy("Last 7 Days");
    handleFilterCompanyChange({
      label: getAllCompanyList[0].name + "-" + getAllCompanyList[0].type,
      value: getAllCompanyList[0].id,
    });
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  };

  useEffect(() => {
    if (filteredData) {
      var newFilteredData = data
        .filter((item: any) => {
          if (statusFilter && item.Status !== statusFilter) {
            return false;
          }
          if (companyFilter && item.CompanyName !== companyFilter) {
            return false;
          }
          // Apply date range filter (if dates are selected)
          if (selectedStartDate && selectedEndDate) {
            const createdDate = new Date(item.CreatedDate);

            // Convert moment objects to Date objects if needed
            const startDate =
              selectedStartDate instanceof Date
                ? selectedStartDate
                : selectedStartDate.toDate();
            const endDate =
              selectedEndDate instanceof Date
                ? selectedEndDate
                : selectedEndDate.toDate();

            // Check if the created date is within the selected date range
            if (createdDate < startDate || createdDate > endDate) {
              return false;
            }
          }
          return true;
        })
        .sort((a: any, b: any) => {
          switch (sortBy) {
            case "Recently Added":
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              );
            case "Ascending":
              return a.CompanyName.localeCompare(b.CompanyName);
            case "Descending":
              return b.CompanyName.localeCompare(a.CompanyName);
            case "Last Month":
              const oneMonthAgo = new Date();
              oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); // Get the date for one month ago
              const lastMonthCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last month, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= oneMonthAgo &&
                new Date(a.CreatedDate) >= oneMonthAgo
              ) {
                return lastMonthCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last month
              }
            case "Last 7 Days":
              const sevenDaysAgo = new Date();
              sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Get the date for 7 days ago
              const last7DaysCreatedDate =
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime();

              // If the created date is within the last 7 days, continue sorting by CreatedDate
              if (
                new Date(b.CreatedDate) >= sevenDaysAgo &&
                new Date(a.CreatedDate) >= sevenDaysAgo
              ) {
                return last7DaysCreatedDate;
              } else {
                return 0; // Do not change order if dates are not within the last 7 days
              }

            default: // 'Last 7 Days'
              return (
                new Date(b.CreatedDate).getTime() -
                new Date(a.CreatedDate).getTime()
              ); // Adjust logic for 'Last 7 Days'
          }
        });
      var dateFilter = [...newFilteredData];
      if (dateFilter.length > 0) {
        setFilteredData(dateFilter); // Update filtered data
      } else {
        if (data.length > 0) {
          setFilteredData([]);
        }
      }
    }
  }, [
    statusFilter,
    sortBy,
    selectedStartDate,
    selectedEndDate,
    filterFormDataAddLeadForm,
  ]);

  const [deleteRecord, setDeleteRecord] = useState<{
    key: number;
    name: string;
  } | null>(null);

  const handleDelete = async () => {
    if (deleteRecord) {
      try {
        var id = deleteRecord.key;
        try {
          setIsLoading(true);
          const response = await api.post("leadService/deleteLEadForm", {
            signature,
            id,
          });
          showBasicAlert(response.data.message[0].msg);
        } catch (error: any) {
          showBasicAlert(error.data.message[0].msg);
        } finally {
          await updateUI();
          setIsLoading(false); // hide loader after response
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Failed to delete item.");
      }
      setDeleteRecord(null);
    }
  };

  const [openFormView, setFormViewOpen] = useState(false);
  const [formData, setFormData] = useState<any>(null);

  const [isEditing, setIsEditing] = useState(false);
  const [editFormName, setEditFormName] = useState("");
  const [editFormId, setEditFormId] = useState(null);

  const handleEditForm = async (form: any) => {
    setSelectedEmployees(form.employees);
    const [getLeadSettings] = await Promise.all([
      api.post("leadService/getAllLeadSettings", {
        signature,
        company_id: parseInt(form.CompanyId),
        company_type: form.CompanyType.trim(),
      }),
    ]);
    if (getLeadSettings.data.data.data.length > 0) {
      const [getAllEmployeList] = await Promise.all([
        api.post("userService/getLeadEmployeesListData", {
          signature,
          department:
            getLeadSettings?.data?.data?.data[0]?.settings
              ?.lead_assigned_to_department || -1,
          company_id: parseInt(form.CompanyId),
          company_type: form.CompanyType.trim(),
        }),
      ]);
      setEditFormId(form.key); // Store the form ID
      setEditFormName(form.LeadFormName);
      setFields(form.structure || []); // Load the form fields
      setIsEditing(true);
      setLeadEmployeesList(getAllEmployeList.data.data.data.allUsers);
    } else {
      setLeadEmployeesList([]);
    }
  };

  const handleUpdateForm = async () => {
    if (!editFormName.trim() || setFields.length === 0) {
      showBasicAlert("Please Enter a form name.");
      return;
    }

    const hasMobile = fields.some((field) => field.label === "Mobile No");

    if (!hasMobile) {
      showBasicAlert("Mobile No. must be provided.");
      return;
    }

    try {
      const response = await api.post("leadService/updateLeadForm", {
        signature: signature,
        id: editFormId,
        formName: editFormName,
        structure: fields,
        selectedEmployees: selectedEmployees,
      });

      updateUI();
      showBasicAlert(response.data.message[0].msg);
      document.getElementById("close-lead-edit-form")?.click();
      setIsEditing(false); // Close modal
    } catch (error: any) {
      showBasicAlert(error.data.message[0].msg);
    }
  };

  const handleStatusChange = (e: any, status: string): any => {
    e.preventDefault();
    setStatusFilter(status);
  };

  if (
    getAllCompanyList.length == 0 &&
    filteredData.length > 0 &&
    data.length > 0
  ) {
    return <Loader />;
  } else {
    return (
      <>
        {isLoading && <Loader />}
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Leads Form</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">CRM</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Lead Forms
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                <div className="mb-2 ms-2">
                  <CommonSelect
                    className="select me-3"
                    options={companyChoose}
                    defaultValue={{
                      value: filterFormDataAddLeadForm.companyId,
                      label:
                        filterFormDataAddLeadForm.companyName +
                        "-" +
                        filterFormDataAddLeadForm.companytype,
                    }}
                    onChange={handleFilterCompanyChange}
                  />
                </div>

                <div className="mb-2 ms-2">
                  <Link
                    to="#"
                    onClick={(e: any) => e.preventDefault()}
                    data-bs-toggle="modal"
                    data-bs-target="#add_leads_form"
                    className="btn btn-primary d-flex align-items-center">
                    <i className="ti ti-circle-plus me-2" />
                    Add Lead Form
                  </Link>
                </div>
                <div className="head-icons ms-2">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Leads List */}
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Leads Form List</h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges onDateChange={handleDateChange} />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>

                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                      onClick={(e: any) => e?.preventDefault()}>
                      Status {statusFilter}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            handleStatusChange(e, "Active");
                          }}>
                          Active
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            handleStatusChange(e, "Inactive");
                          }}>
                          Inactive
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                      onClick={(e: any) => e.preventDefault()}>
                      Sort By: {sortBy}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Recently Added");
                          }}>
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Ascending");
                          }}>
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Descending");
                          }}>
                          Descending
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last Month");
                          }}>
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="dropdown-item rounded-1"
                          onClick={(e: any) => {
                            e.preventDefault();
                            setSortBy("Last 7 Days");
                          }}>
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={handleReset}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <Table
                  key={JSON.stringify(filteredData)}
                  dataSource={filteredData}
                  columns={columns}
                  Selection={false}
                />
              </div>
            </div>
            {/* /Leads List */}
            <div className="mt-3">
              <SharedFormLists
                key={shareLinksRefreshKey}
                selectedCompany={filterFormDataAddLeadForm}
              />
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © CMS.</p>
            <p>
              Designed & Developed By{" "}
              <Link
                to="#"
                className="text-primary"
                onClick={(e: any) => e.preventDefault()}>
                ZYVO
              </Link>
            </p>
          </div>
        </div>

        <div className="modal fade" id="add_leads_form">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Lead Form</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i className="ti ti-x" />
                </button>
              </div>

              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input-block mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="col-form-label">
                            Company <span className="text-danger"> *</span>
                          </label>
                          {/* <Link to="#">
                            <i className="ti ti-plus text-primary me-1" />
                            Add New
                          </Link> */}
                        </div>
                        <CommonSelect
                          className="select"
                          options={companyChoose}
                          defaultValue={{
                            value: formDataAddLeadForm.companyId,
                            label:
                              formDataAddLeadForm.companyName +
                              "-" +
                              formDataAddLeadForm.companytype,
                          }}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input-block mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="col-form-label">
                            Lead Pipeline{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          {/* <Link to="#">
                            <i className="ti ti-plus text-primary me-1" />
                            Add New
                          </Link> */}
                        </div>
                        <select
                          className="form-control"
                          name="pipelineId"
                          value={formDatapipeline.pipelineId}
                          onChange={handleInputPipelineChange}>
                          <option value="">Select</option>
                          {leadPipelineChoose.map((pipeline) => (
                            <option key={pipeline.key} value={pipeline.key}>
                              {pipeline.Pipeline_Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input-block mb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="col-form-label">
                            Deal Pipeline{" "}
                          </label>
                          {/* <Link to="#">
                            <i className="ti ti-plus text-primary me-1" />
                            Add New
                          </Link> */}
                        </div>
                        <select
                          className="form-control"
                          name="dealpipelineId"
                          value={formDatadealpipeline.dealpipelineId}
                          onChange={handleInputdealPipelineChange}>
                          <option value="">Select</option>
                          {dealPipelineChoose.map((pipeline) => (
                            <option key={pipeline.key} value={pipeline.key}>
                              {pipeline.Pipeline_Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-form-label">
                          Select Employee{" "}
                          <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="input-block mb-3">
                        <FormControl fullWidth size="small">
                          <InputLabel>Select Employees</InputLabel>
                          <Select
                            multiple
                            value={selectedEmployees}
                            onChange={handleEmployeeChange}
                            input={<OutlinedInput label="Select Employees" />}
                            renderValue={(selected) =>
                              selected.map((id) => {
                                const employee = employeesList.find(
                                  (e: any) => e.value === id
                                );
                                return employee ? (
                                  <Chip
                                    key={id}
                                    label={employee.label}
                                    style={{ margin: "1px" }}
                                  />
                                ) : null;
                              })
                            }>
                            {employeesList.map((employee: any) => (
                              <MenuItem
                                key={employee.value}
                                value={employee.value}>
                                <Checkbox
                                  checked={
                                    selectedEmployees.indexOf(employee?.value) >
                                    -1
                                  }
                                  style={{ marginRight: 8 }}
                                />
                                {employee.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-form-label">
                          Form Name
                          <span className="text-danger"> *</span>
                        </label>
                        {/* <Link to="#">
                            <i className="ti ti-plus text-primary me-1" />
                            Add New
                          </Link> */}
                      </div>
                      <TextField
                        label="Form Name"
                        fullWidth
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "10px",
                        }}
                        size="small"
                      />
                    </div>
                    {fields.map((field) => (
                      <div className={"col-md-6"} key={field.id}>
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="col-form-label">
                            {field.label}
                            <span
                              className={field.required ? "text-danger" : ""}>
                              {field.required ? " *" : " (Optional)"}
                            </span>
                          </label>
                          {/* <Link to="#">
                            <i className="ti ti-plus text-primary me-1" />
                            Add New
                          </Link> */}
                        </div>
                        <div className="col-md-12">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              width: "100%",
                            }}>
                            <TextField
                              label="Label"
                              value={field.label}
                              onChange={(e) =>
                                handleFieldChange(
                                  field.id,
                                  "label",
                                  e.target.value
                                )
                              }
                              size="small"
                              required={field.required}
                              disabled={field.required}
                              style={{ flexGrow: 1 }} // Ensures it takes available space
                            />
                            {field.id !== 1 && field.id !== 3 && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={field.required}
                                    onChange={(e) =>
                                      handleFieldChange(
                                        field.id,
                                        "required",
                                        e.target.checked
                                      )
                                    }
                                    color="primary"
                                  />
                                }
                                label="Required"
                              />
                            )}

                            {field.id !== 1 && field.id !== 3 && (
                              <IconButton
                                onClick={() => removeField(field.id)}
                                color="error">
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </div>
                        </div>

                        {field.type === "select" && (
                          <TextField
                            label="Options (comma separated)"
                            onChange={(e) =>
                              handleFieldChange(
                                field.id,
                                "options",
                                e.target.value.split(",")
                              )
                            }
                            size="small"
                            style={{ marginTop: "10px", width: "100%" }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-body pb-0">
                  <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-md-3" style={{ textAlign: "left" }}>
                      <select
                        className="form-control"
                        name="pipelineId"
                        value={formDatapipeline.pipelineId}
                        onChange={handleSelect}>
                        <option value="">Add More Fields</option>
                        {dynamicColumn.map((column) => (
                          <option key={column.value} value={column.value}>
                            {column.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-9" style={{ textAlign: "right" }}>
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                        id="close-btn-lead-form">
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={saveForm}>
                        Add Lead Form
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="modal fade" id="edit_leads_form">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Lead Form</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    window.location.reload();
                  }}>
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body pb-0">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <label className="col-form-label">
                          Form Name
                          <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <TextField
                        label="Form Name"
                        fullWidth
                        value={editFormName}
                        onChange={(e) => setEditFormName(e.target.value)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "10px",
                        }}
                        size="small"
                      />
                    </div>
                    {fields.map((field) => (
                      <div className={"col-md-6"} key={field.id}>
                        <div className="d-flex justify-content-between align-items-center">
                          <label className="col-form-label">
                            {field.label}
                            <span
                              className={field.required ? "text-danger" : ""}>
                              {field.required ? " *" : " (Optional)"}
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              width: "100%",
                            }}>
                            <TextField
                              label="Label"
                              value={field.label}
                              onChange={(e) =>
                                handleFieldChange(
                                  field.id,
                                  "label",
                                  e.target.value
                                )
                              }
                              size="small"
                              required={field.required}
                              disabled={field.required}
                              style={{ flexGrow: 1 }} // Ensures it takes available space
                            />

                            {field.id !== 1 && field.id !== 3 && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={field.required}
                                    onChange={(e) =>
                                      handleFieldChange(
                                        field.id,
                                        "required",
                                        e.target.checked
                                      )
                                    }
                                    color="primary"
                                  />
                                }
                                label="Required"
                              />
                            )}
                            {field.id !== 1 && field.id !== 3 && (
                              <IconButton
                                onClick={() => removeField(field.id)}
                                color="error">
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </div>
                        </div>

                        {field.type === "select" && (
                          <TextField
                            label="Options (comma separated)"
                            onChange={(e) =>
                              handleFieldChange(
                                field.id,
                                "options",
                                e.target.value.split(",")
                              )
                            }
                            value={field.options?.join(", ")}
                            size="small"
                            style={{ marginTop: "10px", width: "100%" }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="col-form-label">
                        Select Employee <span className="text-danger"> *</span>
                      </label>
                    </div>
                    <div className="input-block mb-3">
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Employees</InputLabel>
                        <Select
                          multiple
                          value={selectedEmployees}
                          onChange={handleEmployeeChange}
                          input={<OutlinedInput label="Select Employees" />}
                          renderValue={(selected) =>
                            selected.map((id) => {
                              const employee = employeesList.find(
                                (e: any) => e.value === id
                              );
                              return employee ? (
                                <Chip
                                  key={id}
                                  label={employee.label}
                                  style={{ margin: "1px" }}
                                />
                              ) : null;
                            })
                          }>
                          {employeesList.map((employee: any) => (
                            <MenuItem
                              key={employee.value}
                              value={employee.value}>
                              <Checkbox
                                checked={selectedEmployees.includes(
                                  employee.value
                                )}
                                style={{ marginRight: 8 }}
                              />
                              {employee.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div className="modal-body pb-0">
                  <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-md-3" style={{ textAlign: "left" }}>
                      <select
                        className="form-control"
                        name="pipelineId"
                        value={formDatapipeline.pipelineId}
                        onChange={handleSelect}>
                        <option value="">Add More Fields</option>
                        {dynamicColumn.map((column) => (
                          <option key={column.value} value={column.value}>
                            {column.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-9" style={{ textAlign: "right" }}>
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          window.location.reload();
                        }}
                        id="close-lead-edit-form">
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleUpdateForm}>
                        Update Lead Form
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <LeadFormViewer
          open={openFormView}
          onClose={() => setFormViewOpen(false)}
          data={formData}
        />

        <DeleteModal
          modalId="delete_modal"
          onDelete={handleDelete}
          title="Delete Item"
          message="Are you sure you want to delete this item? This action cannot be undone."
        />

        <GenerateShareLinkModal
          isOpen={isGenerateLinkModalOpen}
          onClose={handleCloseGenerateLinkModal}
          selectedForm={selectedFormForSharing}
          onSuccess={handleShareLinkSuccess}
        />
      </>
    );
  }
};

export default LeadsFormList;
